module.exports = __webpack_public_path__ + "static/media/radio_wave.6b88534e.jpg";